import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { OpposingPartyStyle } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import messages from 'containers/PreOpeningPage/messages';
import { translate } from 'containers/services/translate';
import { FormContainer } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import SahamAccordion from 'components/SahamAccordion';
import OpposingPartyForm from 'containers/PreOpeningPage/OpposingParty/OpposingPartyForm';
import { Listings } from 'containers/AppContainer/typings';
import { getLabels } from 'containers/PreOpeningPage/OpposingParty/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
export interface OpposingPartyRecapProps {
  intl: IntlShape;
  vehicule: Vehicule;
  expanded: boolean[];
  setExpanded: React.Dispatch<React.SetStateAction<boolean[]>>;
  claimToPreopen: any;
  setClaimToPreopen: React.Dispatch<React.SetStateAction<any>>;
  index: number;
  setRenderForm: React.Dispatch<React.SetStateAction<boolean>>;
  setToggleOpen: React.Dispatch<React.SetStateAction<boolean>>;
  listings: Listings;
  isForDrawer: boolean;
  isFromSagis?: boolean;
  sagisOpposingParties: any;
}

const OpposingPartyRecap: React.FC<OpposingPartyRecapProps> = ({
  vehicule,
  expanded,
  setExpanded,
  claimToPreopen,
  setClaimToPreopen,
  setRenderForm,
  setToggleOpen,
  listings,
  index,
  isFromSagis,
  ...props
}): JSX.Element => {
  const [expandedd, setExpandedd] = React.useState<boolean>(true);
  const handleClick = (event: React.ChangeEvent<{}>, expandedd: boolean) => {
    setExpandedd(expandedd);
  };
  const handleDelete = () => {
    setClaimToPreopen(
      Object.assign(
        {},
        { ...claimToPreopen },
        {
          opposingParty: {
            hasMaterialDammage: claimToPreopen.opposingParty.hasMaterialDammage,
            vehicules: [...claimToPreopen.opposingParty.vehicules].filter(
              el => !(el.registrationNumber === vehicule.registrationNumber),
            ),
            newVehicles: [...claimToPreopen.opposingParty?.newVehicles].filter(
              el => !(el.registrationNumber === vehicule.registrationNumber),
            ),
          },
        },
      ),
    );
    if (
      claimToPreopen.opposingParty.vehicules.length === 1 ||
      claimToPreopen?.opposingParty?.newVehicles.length === 1
    ) {
      setToggleOpen(true);
      setRenderForm(true);
    }
  };
  const isCourtMonitoringManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMONITORINGMANAGER,
  );
  return (
    <OpposingPartyStyle>
      <SahamAccordion
        title={translate(messages.opposingParty, props, {
          number: index + 1,
        })}
        deleteButtonTitle={
          isCourtMonitoringManager || isFromSagis
            ? undefined
            : translate({ ...messages.delete }, props)
        }
        expanded={expandedd}
        onChange={handleClick}
        accordionDetailsClassName="collapse-recap"
        deleteButtonOnClick={
          isCourtMonitoringManager || isFromSagis ? undefined : handleDelete
        }
      >
        <>
          <FormContainer>
            <OpposingPartyForm
              vehicule={{
                ...vehicule,
                ...(getLabels(listings, vehicule) as Vehicule),
              }}
              customClass="formEl"
              readOnly
              listings={listings}
              isForDrawer={props.isForDrawer}
              sagisOpposingParties={props.sagisOpposingParties}
            />
          </FormContainer>
        </>
      </SahamAccordion>
    </OpposingPartyStyle>
  );
};

export default injectIntl(OpposingPartyRecap);
